<app-modal title="Synchroniser le client" size="sm" closeLabel="Fermer" (closed)="annuler()">
  <p class="description">
    La synchronisation recopie les options <strong>et la connection string</strong> d'une source vers l'autre.
    Choisissez le sens :
  </p>

  <div class="choix_sens">
    <button
      type="button"
      appButton
      variant="outline"
      icon="arrow-right"
      class="bouton_sens"
      (click)="choisir('annuaireVersTenant')"
    >
      <span class="libelle_sens">
        <span class="titre_sens">Annuaire vers tenant</span>
        <span class="detail_sens">Les valeurs du legacy écrasent la configuration Azure</span>
      </span>
    </button>

    <button
      type="button"
      appButton
      variant="outline"
      icon="arrow-left"
      class="bouton_sens"
      (click)="choisir('tenantVersAnnuaire')"
    >
      <span class="libelle_sens">
        <span class="titre_sens">Tenant vers annuaire</span>
        <span class="detail_sens">Les valeurs de la configuration Azure écrasent le legacy</span>
      </span>
    </button>
  </div>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
  </div>
</app-modal>
